import Typeson from 'typeson';

const userObject = {
    userObject: {
        test (x, stateObj) { return Typeson.isUserObject(x); },
        replace (n) { return {...n}; },
        revive (s) { return s; }
    }
};

export default userObject;
